<template lang="pug">
  DrawerContents#giftcard-balance-check
    BalanceCheck(@balance="remaining = $event")
    template(#bottom)
      .giftcard-balance-footer
        .row
          .text {{ __('Remaining Balance') }}
          .val {{ $rogue.currency(remaining) }}
</template>
<script setup lang="ts">
import { defineAsyncComponent, ref } from 'vue'

/* There is a refactor effort required here to move DrawerContents to a SISU component so that this drawer (and others)
   can be built in RogueBuilder. */
const BalanceCheck = defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */ '@/js/pages/product/components/balance-check.vue'))

const remaining = ref<number | null>(null)
</script>

<style lang="scss" scoped>

  #giftcard-balance-check:deep() {
    .drawer-container {
      max-width: 320px;
    }

    .drawer-header .h-right {
      display: none;
    }

    .drawer-footer {
      background-color: $color-gray-x-light;
    }

    .close {
      display: none;
    }

    .field-error {
      margin-top: $space-xxxs;
    }
  }

  .text {
    color: $color-black-light;
    font-size: $size-s;
  }

  .val {
    font-size: $size-xs;
    font-weight: $weight-bold;
  }

  .giftcard-balance-footer {
    background-color: $color-gray-x-light;
  }

  .row {
    display: flex;
    justify-content: space-between;
    padding: $space-xs;
    border: $border-width-thin solid $color-gray-light;
  }

</style>
